<template>
  <el-dialog
    :model-value="modelValue"
    :title="title"
    width="400px"
    @close="emit('update:modelValue', false)"
  >
    <div v-if="useHtmlMessage" v-html="message" />
    <span v-else>
      <b>{{ message }}</b>
    </span>
    <template #footer>
      <el-button size="large" @click="emit('update:modelValue', false)">
        {{ cancelText }}
      </el-button>
      <el-button
        size="large"
        :type="confirmType"
        :loading="loading"
        @click="emit('confirm')"
      >
        {{ confirmText }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
  withDefaults(
    defineProps<{
      modelValue: boolean;
      title: string;
      message: string;
      confirmText?: string;
      cancelText?: string;
      confirmType?: 'primary' | 'success' | 'warning' | 'danger' | 'info';
      loading?: boolean;
      useHtmlMessage?: boolean;
    }>(),
    {
      confirmText: '実行',
      cancelText: 'キャンセル',
      confirmType: 'primary',
      loading: false,
      useHtmlMessage: false
    }
  );

  const emit = defineEmits<{
    (e: 'update:modelValue', value: boolean): void;
    (e: 'confirm'): void;
  }>();
</script>
